// extracted by mini-css-extract-plugin
export default {"wrapper":"bY-z","firstToReview":"cY-z","productCards":"dY-z","productCard":"eY-z","stars":"fY-z","hidden":"gY-z"};